export const OPTIONS_DIAS = [
    { value: 1, label: 'Até 1 dia após o pedido' },
    { value: 2, label: 'Até 2 dias após o pedido' },
    { value: 3, label: 'Até 3 dias após o pedido' },
    { value: 4, label: 'Até 4 dias após o pedido' },
    { value: 5, label: 'Até 5 dias após o pedido' },
    { value: 6, label: 'Até 6 dias após o pedido' }
];

export const OPTIONS_INTERVALOS = [
    { value: 3, label: '3 minutos' },
    { value: 5, label: '5 minutos' },
    { value: 15, label: '15 minutos' },
    { value: 20, label: '20 minutos' },
    { value: 30, label: '30 minutos' },
    { value: 40, label: '40 minutos' },
    { value: 45, label: '45 minutos' },
    { value: 50, label: '50 minutos' },
    { value: 60, label: '60 minutos' },
    { value: 90, label: '90 minutos' },
    { value: 120, label: '120 minutos' },
    { value: 150, label: '150 minutos' },
    { value: 180, label: '180 minutos' }
];
